var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 11.625C20.75 17.25 12.875 22.5 12.875 22.5C12.875 22.5 5 17.25 5 11.625C5 9.53642 5.82968 7.53338 7.30653 6.05653C8.78338 4.57969 10.7864 3.75 12.875 3.75C14.9636 3.75 16.9666 4.57969 18.4435 6.05653C19.9203 7.53338 20.75 9.53642 20.75 11.625Z",
    stroke: "#1D252D",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 13.4998C13.9115 13.4998 14.751 12.6603 14.751 11.6248C14.751 10.5892 13.9115 9.74976 12.876 9.74976C11.8404 9.74976 11.001 10.5892 11.001 11.6248C11.001 12.6603 11.8404 13.4998 12.876 13.4998Z",
    fill: "#1D252D",
    stroke: "#1D252D",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3ba8abdfe8e60ff6c14cda7439d322ae.svg";
export { ForwardRef as ReactComponent };